// Fork: helpers for backdated notes and public update status labels.
export const STATUS_LABEL_OPTIONS = ['Investigating', 'Identified', 'Monitoring', 'Resolved']

const pad = (value: number) => String(value).padStart(2, '0')

/** ISO timestamp → value for a local datetime-local input. */
export function toLocalInputValue(iso: string): string {
  const date = new Date(iso)
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

/** datetime-local value (local time) → ISO timestamp. */
export function fromLocalInputValue(value: string): string {
  return new Date(value).toISOString()
}

/** Current local time as a datetime-local value, used as the input's max. */
export function nowInputValue(): string {
  return toLocalInputValue(new Date().toISOString())
}
